
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},
})
export default class Available extends Vue {
  data() {
    return {
      ZeroHeightLink: process.env.VUE_APP_ZERO_HEIGHT_LINK,
    };
  }
}
